"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PairWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../themes/colors");
exports.PairWrapper = styled_components_1.default.div `
  display: flex;
  flex-flow: row nowrap;

  & > div {
    border-radius: 50%;
    background-color: ${colors_1.colors.white};
    height: fit-content;

    & > img {
      overflow: hidden;
    }
  }

  & > div:last-child {
    border-radius: 50%;
    border: 2px solid ${colors_1.colors.shade10};
    margin-left: -10px;
    margin-top: 2px;

    & > img {
      overflow: hidden;
    }
  }
`;
//# sourceMappingURL=styled.js.map